



































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TextLabelNewArrivalCount from "@/common/components/atoms/TextLabelNewArrivalCount.vue";
// import * as dropdownAnimation from '../../../../assets/js/mixins/dropdownAnimation.js';
import commons from "@/common/store/modules/commons";
@Component({
  components: {
    TextLabelNewArrivalCount
  }
})
export default class TheHeaderNaviChildOnAdmin extends Vue {
  @Prop({ type: [Array, Boolean], default: false }) childList!: boolean;
  @Prop({ type: Boolean, default: false }) shown!: boolean;
  @Prop({ type: Number, default: 0 }) thanksPointCount!: number;

  get colorCode() {
    return commons?.colorCode;
  }

  // mixins: any = [dropdownAnimation];
  isOpen: any = false;
  hoverColor: any = {
    true: this.colorCode,
    false: "#616161"
  };
  currentHoverElementKey = -1;
  adminNotificationCount: any;

  isHover(currentKey: any) {
    return this.currentHoverElementKey === currentKey;
  }

  @Watch("shown")
  onPropertyChanged(newValue: any, oldValue: string) {
    this.isOpen = newValue;
  }

  created() {
    this.isOpen = this.shown;
  }

  mounted() {
    this.initCustomColor();
  }

  initCustomColor() {
    const { colorCode } = this;
    this.hoverColor.true = colorCode;
  }

  mouseover(elementKey: any) {
    this.currentHoverElementKey = elementKey;
  }

  mouseleave() {
    this.currentHoverElementKey = -1;
  }
  getNotificationCount(hasNotification: any) {
    if (hasNotification) {
      const thankspointCount = this.thanksPointCount;
      return thankspointCount > 9 ? "..." : thankspointCount;
    } else {
      return false;
    }
  }
}
